module.exports = __webpack_public_path__ + "img/Z85-X18-中_12.2e93c431.jpg";